import * as React from 'react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import { BarcodeListener } from '../../../../../components/BarcodeListener'
import { IBaseProduct, API } from '@getgreenline/homi-shared'
import { Track } from '../../../../../Track'

interface Props {
  companyId: number
  onClose: () => void
  onScanSuccess: (product: IBaseProduct, lot?: string) => void
}

interface State {
  barcode?: string
  batchNumber?: string
  product?: IBaseProduct
  message?: {
    type: 'success' | 'error'
    message: string
  }
}

export class BarcodeModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {}
  }

  async onScan(barcode: string, batchNumber?: string) {
    this.setState({
      barcode: barcode,
      batchNumber: batchNumber,
      product: undefined,
      message: undefined,
    })
    const { companyId } = this.props
    const matchingProducts = await API.getFlatProducts(companyId, { barcode })
    if (matchingProducts.length > 0) {
      const product = matchingProducts[0]
      const productName = product.parentProductName
        ? `${product.parentProductName} - ${product.name}`
        : product.name
      this.setState({
        product: product,
        message: {
          type: 'success',
          message: `${productName} successfully added`,
        },
      })
      this.props.onScanSuccess(product, batchNumber)
      Track.track('dashboard:purchaseOrder_barcodeScanned', {
        status: 'success',
        barcode: barcode,
        batchNumber: batchNumber,
      })
    } else {
      this.setState({
        message: {
          type: 'error',
          message: `No products with barcode ${barcode} found`,
        },
      })
      Track.track('dashboard:purchaseOrder_barcodeScanned', {
        status: 'error',
        barcode: barcode,
        batchNumber: batchNumber,
      })
    }
  }

  render() {
    const { message, barcode, batchNumber } = this.state

    return (
      <Modal isOpen={true} toggle={this.props.onClose}>
        <ModalHeader toggle={this.props.onClose}>Scanning barcodes...</ModalHeader>
        <ModalBody>
          <div className='d-flex'>
            <span className='text-muted fa fa-barcode fa-4x mr-4' />
            <div className='text-muted mt-1'>
              Connect your device and scan.
              <br />
              Please keep this popup open while scanning.
            </div>
          </div>
          <br />
          <div>
            <b>Results:</b>
          </div>
          <div>Barcode: {barcode || '-'}</div>
          <div>{batchNumber ? `Lot: ${batchNumber}` : ''}</div>
          <br />
          {message !== undefined && (
            <div
              className={message.type === 'success' ? 'alert alert-success' : 'alert alert-danger'}
            >
              {message.message}
            </div>
          )}
          <BarcodeListener onBarcodeEnter={(barcode, lot) => this.onScan(barcode, lot)} />
        </ModalBody>
      </Modal>
    )
  }
}
